/* unplugin-vue-components disabled */import { mapState, mapActions } from 'vuex';
export default {
  name: 'iHeaderFullscreen',
  computed: {
    ...mapState('admin/layout', ['isFullscreen'])
  },
  methods: {
    ...mapActions('admin/layout', ['toggleFullscreen'])
  }
};